import { Toast, ToastMessage } from "primereact/toast";
import { useEffect, useRef } from "react";

/**
 * Substitui o "notiflix" por notificacoes baseadas no Toast do primereact
 * (ja utilizado no projeto). Expõe uma API global compativel com a anterior
 * (Notify.success/failure/warning/info), evitando ter que adicionar um
 * componente <Toast/> com ref em cada pagina.
 *
 * Uso: monte <NotifyAnchor /> uma unica vez na raiz da aplicacao (App.tsx).
 */

let toastRef: Toast | null = null;

const show = (severity: ToastMessage["severity"], summary: string, detail: string) => {
  toastRef?.show({ severity, summary, detail, life: 3000 });
};

export const Notify = {
  success: (message: string) => show("success", "Sucesso", message),
  failure: (message: string) => show("error", "Erro", message),
  warning: (message: string) => show("warn", "Atenção", message),
  info: (message: string) => show("info", "Informação", message),
};

export const NotifyAnchor = () => {
  const ref = useRef<Toast>(null);

  useEffect(() => {
    toastRef = ref.current;
    return () => {
      toastRef = null;
    };
  }, []);

  return <Toast ref={ref} position="top-right" />;
};
